import UserLayout from '@/components/UserLayout'


/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = [

]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
    {
        path: '/',
        component: UserLayout,
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: 'home',
                meta: { title: '首页', componentName: "home", keepAlive: false },
                component: () => import('@/views/Home'),
            },
            {
                path: 'searchPolicy',
                name: 'searchPolicy',
                meta: { title: '政策大厅', componentName: "searchPolicy", keepAlive: false },
                component: () => import('@/views/policy/PolicySearch'),
            },
            {
                path: 'policyDetail',
                name: 'policyDetail',
                meta: { title: '政策详情', componentName: "PolicyDetail", keepAlive: false },
                component: () => import('@/views/policy/PloicyDetail'),
            },
            {
                path: 'showDemand',
                name: 'showDemand',
                meta: { title: '需求详情', componentName: "DemandShow", keepAlive: false },
                component: () => import('@/views/demand/DemandDetail'),
            },
            {
                path: 'searchDemand',
                name: 'searchDemand',
                meta: { title: '需求搜索', componentName: "searchDemand", keepAlive: false },
                component: () => import('@/views/demand/DemandSearch'),
            },
            // {
            //     path: 'addDemand',
            //     name: 'addDemand',
            //     meta: { title: '发布需求', componentName: "addDemand", keepAlive: false },
            //     component: () => import('@/views/demand/DemandAdd'),
            // },
            {
                path: 'ProductCenter',
                name: 'ProductCenter',
                meta: { title: '产品中心', componentName: "ProductCenter", keepAlive: false },
                component: () => import('@/views/product/ProductCenter'),
        
            },
            {
                path: 'showProduct',
                name: 'showProduct',
                meta: {title: '产品详情',componentName:"showProduct",keepAlive: false},
                component: () => import('@/views/product/ProductDetail'),
            },
            {
                path: 'EnterpriseCenter',
                name: 'EnterpriseCenter',
                meta: {title: '服务商库',componentName:"EnterpriseCenter",keepAlive: false},
                component: () => import('@/views/service/EnterpriseCenter'),
     
              },
              {
                path: 'showEnterprise/:id',
                name: 'showEnterprise',
                meta: {title: '服务商详情',componentName:"showEnterprise",keepAlive: false},
                component: () => import('@/views/service/EnterpriseDetail'),
                beforeEnter: (to, from, next) => {
                    // 可以在这里获取到to.params.id，即要访问的用户的ID
                    // console.log('即将访问的ID:', to.params.id);
                    next(); // 确保调用next()，否则钩子不会解决
                  }
              },
              {
                path: 'showService',
                name: 'showService',
                meta: {title: '服务详情',componentName:"showService",keepAlive: false},
                component: () => import('@/views/service/modules/ServiceDetail'),
              },
              
              {
                path: 'PlatformCenter',
                name: 'PlatformCenter',
                meta: {title: '平台简介',componentName:"PlatformCenter",keepAlive: false},
                component: () => import('@/views/platform/PlatformCenter'),
              },
              {
                path: 'SpecialtyCenter',
                name: 'SpecialtyCenter',
                meta: {title: '特色专区',componentName:"SpecialtyCenter",keepAlive: false},
                component: () => import('@/views/platform/SpecialtyCenter'),
              },
              {
                path: 'showCase',
                name: 'showCase',
                meta: {title: '案例详情',componentName:"showCase",keepAlive: false},
                component: () => import('@/views/platform/CaseDetail'),
              }
        ]
    },
]
